// extracted by mini-css-extract-plugin
export default {"cart":"favorites_cart__hDmj2","mySwiper":"favorites_mySwiper__AH40C","mySwiperSlice":"favorites_mySwiperSlice__F5+dj","title":"favorites_title__pqyC0"};